<input
  type="text"
  pInputText
  [formControl]="keyword"
  class="w-full"
  placeholder="Cerca..."
/>
<div class="mh-500 mt-3">
  <p-progressBar
    mode="indeterminate"
    [style]="{ height: '6px' }"
    *ngIf="loading"
  />
  <div *ngIf="results">
    <p class="text-xs">
      <em
        >Foto da
        <a href="https://www.unsplash.com" target="_blank" class="text-xs"
          >Unsplash</a
        ></em
      >
    </p>
    <div class="grid">
      <div class="col-4 md:col-2" *ngFor="let p of results.list">
        <a
          href="#"
          (click)="selectImage($event, p)"
          class="image-preview relative flex align-items-end justify-content-center overflow-hidden"
          [class.selected]="isSelected(p)"
          [ngStyle]="{ 'background-image': 'url(' + p.urls.small + ')' }"
        >
          <small
            class="absolute bottom-0 p-2 text-white text-xs font-italic opacity-0 transition-opacity duration-200"
          >
            {{ p.author }}
          </small>
        </a>
      </div>
    </div>
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [rows]="limit"
      [totalRecords]="results.count"
      [showCurrentPageReport]="true"
      [showPageLinks]="false"
      [showFirstLastIcon]="false"
      [showJumpToPageDropdown]="false"
      currentPageReportTemplate="{totalRecords} immagini trovate"
    />

    <div class="flex align-items-center justify-content-end">
      <p-button
        styleClass="slide px-6"
        label="Conferma selezione"
        (click)="confirmSelection()"
        class="mt-3"
      />
    </div>
  </div>
</div>
